module.exports = __webpack_public_path__ + "img/bg_avatar_female_47.12f6fe14.png";